import { Directive, HostListener, Input } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  ValidatorFn
} from '@angular/forms';
import isValid from 'date-fns/isValid';
import parse from 'date-fns/parse';

const malaysia = 'malaysia';
// const philippines = 'philippines';
// 柬埔寨自然人
const cambodiaIndividual = 'cambodia';
// 柬埔寨法人
const cambodiaCorporate = 'cambodia';

@Directive({
  selector: '[appCheckId]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: CheckIdDirective,
      multi: true,
    },
  ],
})
export class CheckIdDirective {
  @Input() appCheckCountryId = 'none';
  @Input() control!: AbstractControl | null;
  isFocus = false;
  constructor() {}

  @HostListener('blur')
  onblur(): void {
    this.isFocus = false;
    this.control?.updateValueAndValidity();
  }

  @HostListener('focus')
  onfocus(): void {
    this.isFocus = true;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if (this.isFocus) {
      return null;
    } else {
      return control.value
        ? checkIdDirectiveValidator(this.appCheckCountryId)(control)
        : null;
    }
  }
}

export function checkIdDirectiveValidator(idType: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let regString!: RegExp;
    let regResult: ValidationErrors | null = { idNotAllow: true };
    if (control.value === null) {
      return null;
    } else {
      switch (idType) {
        case malaysia:
          regString = /^[0-9]{12,12}$/;
          regResult =
            regString.test(control.value) &&
            isValid(parse(control.value.substr(0, 6), 'yyMMdd', new Date()))
              ? null
              : regResult;
          break;
        case cambodiaIndividual:
          regString = /^[0-9]{9,9}$/;
          regResult = regString.test(control.value) ? null : regResult;
          break;
        case cambodiaCorporate:
          regString = /^[0-8]{8,8}$/;
          regResult = regString.test(control.value) ? null : regResult;
          break;
        default:
          regResult = null;
          break;
      }
      return regResult;
    }
  };
}
